import React from 'react';
import { motion } from 'framer-motion';

const EntranceMotion = ({children, initialY, delay, duration, style}) => {
    return (
        <>
            <motion.div
            initial={{ y: (initialY ?? -50), opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: (duration ?? 1), delay: (delay ?? 0), type: "spring", stiffness: 260, damping: 20 }}
            style={style}
            >
                {children}
            </motion.div>
        </>
    );
}

export default EntranceMotion;